import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'

export default function LibraryPickerFooter({
  selectedCount,
  onDeselectAll,
  onApply,
}) {
  const { t } = useTranslation()
  const hasSelection = selectedCount > 0

  return (
    <div className="library-picker-footer">
      <p className="library-picker-footer__title">
        {t('Library.deleteModal.selectedPopup.selectedCount', { count: selectedCount })}
      </p>

      <div className="library-picker-footer__buttons">
        <TransparentBgButton
          onClick={onDeselectAll}
          text={t('Library.libraryPicker.deselectAll')}
          color="navy"
          fullWidth={false}
          disabled={!hasSelection}
        />

        <SecondaryButton
          text={t('Library.libraryPicker.apply')}
          onClick={onApply}
          color="navy"
          fullWidth={false}
          disabled={!hasSelection}
        />
      </div>
    </div>
  )
}

LibraryPickerFooter.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onDeselectAll: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
}
